import { render, staticRenderFns } from "./BdrNewTasks.vue?vue&type=template&id=12dcecc6"
import script from "./BdrNewTasks.vue?vue&type=script&lang=js"
export * from "./BdrNewTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports